export default __webpack_public_path__ + "static/media/user-img-2.500b852e.webp";